import { useQuery } from 'react-query';
import { network } from 'services/network';

const getLargestAddedActivitiesTableData = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filterData,
    };
    return network
        .post('api/bo/getLongestAddedActivities', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryLargestAddedActivitiesTableData = (params) => {
    return useQuery(['largestAddedActivitiesTableData', params], () => getLargestAddedActivitiesTableData(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
